import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from 'react-toolbox/lib/button'
import { mapProps, compose } from 'recompose'
import withAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import { GLOBAL_ROLES, PROJECT_ROLES, PRODUCT_ROLES } from 'containers/Role/constants'

import notifyHoc from 'containers/App/Notification/Notify'

import styles from './styles.scss'

const AddButton = props => {
  return (
    <IconButton
      {...props}
      icon='cloud_upload'
    />
  )
}

AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}
const enhance = compose(
  mapProps((props) => ({
    ...props,
    roles: [
      ...Object.values(PROJECT_ROLES),
      ...Object.values(PRODUCT_ROLES),
      GLOBAL_ROLES.CLIENT_ACCESS,
      GLOBAL_ROLES.ADMIN_ACCESS 
    ]
  })),
  withAnyRoles,
  notifyHoc,
)
export default enhance(AddButton)
